import styled, { css } from "styled-components";

const color = ({ $outline, theme }) => {
  if ($outline) return theme.colors.neutral.white;

  return theme.colors.primary.cetaceanBlue;
};

const backgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.neutral.white;
};

const hoverBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return theme.colors.neutral.gray2;

  return theme.colors.neutral.gray1;
};

const outline = ({ $outline, theme }) => {
  if ($outline) return `2px solid ${theme.colors.neutral.white} `;

  return "none";
};

const focusBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.neutral.white;
};

const focusOutline = ({ theme }) => {
  return `4px solid ${theme.colors.neutral.gray1}`;
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
`;

export const LightButtonStructure = css`
  color: ${color};
  background-color: ${backgroundColor};
  border: ${outline};

  &:hover:not([disabled]) {
    background-color: ${hoverBackgroundColor};
  }

  &:focus {
    background-color: ${focusBackgroundColor};
    outline: ${focusOutline};
  }
`;
